import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { YearOfPassing } from '@app/_models/yearOfPassing';
import { YearOfPassingService } from '@app/_services/masters/yearOfPassing.service';
import { LogService } from '@app/_shared/log.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-passing-year-master-edit',
  templateUrl: './passing-year-master-edit.component.html',
  styleUrls: ['./passing-year-master-edit.component.css']
})
export class PassingYearMasterEditComponent implements OnInit {

  response: any;
  yearId;
  editYearForm: FormGroup;
  yearOfPass;
  submitted: boolean = false;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  yrId;
  getresponse: any;
  strMessage:string;

  get f() { return this.editYearForm.controls; }

  constructor(private eventService: LogService,private formBuilder: FormBuilder, private yearOfPassService: YearOfPassingService,
    private modalService: NgbModal, config: NgbModalConfig) { }

  @Input() childMessage: YearOfPassing[];

  receiveDocumentId(p) {
    this.yearId = p;
  }

  ngOnInit(): void {

    this.response = this.childMessage;
    console.log(this.childMessage)
    console.log(this.response)
    this.yearOfPass = this.response.yearOfPassing;
    this.yrId = this.response.id;
    this.editYearForm = this.formBuilder.group({
      yearOfPass: ['', Validators.required]
    });

  }

  updateYear(){
    this.submitted = true;

    if (this.editYearForm.invalid) {
      return;
    }
    var v = new YearOfPassing();
    v.id = this.yrId;
    v.yearOfPass = this.yearOfPass;
    this.yearOfPassService.updateYear(v)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage="Year Updated Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        
        else if (this.getresponse.respMessage == "Failure") {
          this.strMessage=this.getresponse.respData;
          this.modalService.open(this.showModalBoxTemplate);
          var v = response;
        }
        }
      },
        (err: any) => {
          var message = err;
        });



  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('35');
  } 
  
  goBack()
  {
    this.eventService.emit<string>('35');
  }

}
